import VoicesMyProfile from "../Components/Voices/Profiles/VoicesMyProfile";

const VoicesProfilePage = () => {
  return <VoicesMyProfile />;
};

export default VoicesProfilePage;
